export const DEFAULT_INITIAL_PAGE = 1
export const DEFAULT_INITIAL_PAGE_SIZE = '20'
